import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MdDelete } from 'react-icons/md';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '../../../components/ui/Form';
import { SettingsModalInput } from '../../settings/SettingsModals';
import { Flex } from '../../../components/ui/Flex';
import { Palette } from '../../../components/utils';

const BuildingContactForm = ({ form, index, onRemove, canRemove }) => {
  const { t } = useTranslation();

  return (
    <ContactCard>
      <ContactHeader>
        <ContactTitle>{t('Contact')} {index + 1}</ContactTitle>
        {canRemove && (
          <DeleteButton type="button" onClick={() => onRemove(index)}>
            <MdDelete size={20} />
            {t('Remove')}
          </DeleteButton>
        )}
      </ContactHeader>

      <Flex direction="column" gap="12px">
        <Flex gap="16px">
          <FormField
            control={form.control}
            name={`contacts.${index}.contact_name`}
            render={({ field }) => (
              <FormItem alt>
                <FormLabel v3>{t('Name')}</FormLabel>
                <FormControl row>
                  <SettingsModalInput
                    type="text"
                    placeholder={t('Enter Contact Name')}
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name={`contacts.${index}.phone`}
            render={({ field }) => (
              <FormItem alt>
                <FormLabel v3>{t('Phone')}</FormLabel>
                <FormControl row>
                  <SettingsModalInput
                    type="text"
                    placeholder={t('Enter Phone Number')}
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </Flex>

        <FormField
          control={form.control}
          name={`contacts.${index}.contact_email`}
          render={({ field }) => (
            <FormItem alt>
              <FormLabel v3>{t('Email')}</FormLabel>
              <FormControl row>
                <SettingsModalInput
                  type="email"
                  placeholder={t('Enter Contact Email')}
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </Flex>
    </ContactCard>
  );
};

export default BuildingContactForm;

const DeleteButton = styled.button`
  padding: 4px;
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  color: ${Palette.ERROR};
  font-weight: 500;
  cursor: pointer;

  & > svg {
    margin-right: 4px;
  }
  
  &:hover {
    color: #c93a3a;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ContactCard = styled.div`
  border: 1px solid #d8dbe0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 12px;
  background-color: #f8f9fa;
`;

const ContactHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

const ContactTitle = styled.p`
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${Palette.BLACK};
`;
